// @ vendors
const { APIGet } = require('utilities/APIRequestHelper');

// @ helpers
const apiURLBuilder = require('core/apiURLBuilder');

// @ constants
const actionTypes = require('constants/actionTypes');

function reset() {
    return {
        type: actionTypes.REFERRALS_FORM_RESET
    }
}

function sendEmailsReferralsRequest() {
    return {
        type: actionTypes.REFERRALS_FORM_SUBMIT_REQUEST
    }
}

function copyClipboardSuccess() {
    return {
        type: actionTypes.REFERRALS_FORM_SUBMIT_CLIPBOARD_SUCCESS
    }
}

function sendEmailsReferralsSuccess(response) {
    return {
        type: actionTypes.REFERRALS_FORM_SUBMIT_SUCCESS,
        payload: {
            invitationList: response.invitationList
        }
    }
}

function sendEmailsReferralsFailure(error) {
    return {
        type: actionTypes.REFERRALS_FORM_SUBMIT_FAILURE,
        payload: {
            error
        }
    }
}

function setPromoCode(code){
    return {
        type: actionTypes.REFERRALS_FORM_SET_PROMO_CODE,
        payload: {
            code
        }
    };
}

const sendEmailsReferrals = (code) => (dispatch) => {
    const requestData = {
        header: {
            version: 2
        },
        query: {
            code: code.toUpperCase(),
            channel: 'web'
        }
    };

    dispatch(sendEmailsReferralsRequest());
    return APIGet({
        dispatch,
        endpoint: 'referralsInvitation',
        url: apiURLBuilder.getURL('referralsInvitation'),
        params: requestData
    })
        .then(response => {
            dispatch(sendEmailsReferralsSuccess(response));
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(sendEmailsReferralsFailure(response.error));
            } else {
                throw response;
            }
        });
};

module.exports = {
    copyClipboardSuccess,
    reset,
    sendEmailsReferrals,
    setPromoCode,
};
